import { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { isTokenExpire } from "../utils/token";
import {
  Bars3Icon,
  ChartBarSquareIcon,
  BuildingLibraryIcon,
  ChevronDownIcon,
  ChevronRightIcon,
  ArrowLeftStartOnRectangleIcon,
  QueueListIcon,
  UserGroupIcon,
  BuildingStorefrontIcon,
  MapPinIcon,
} from "@heroicons/react/24/outline";
import { COLOR_AZUL_MAIN } from "../utils/const/colors-const";
import {
  STRING_FALSE,
  STRING_SIDEBAR_EXPANDED_UMV3,
  STRING_TRUE,
} from "../utils/const/string-const";
import { useTranslation } from "react-i18next";
import LayoutHeader from "./layout-header";
import { UserIcon, TriangleAlertIcon, Rotate3DIcon } from "lucide-react";
import { obtenerInfoUsuario } from "../api/api-autenticacion";
import { VERSION_TMS } from "../utils/const/version-const";
import { ChartColumn } from "lucide-react";

const getSideBarStatus = () => {
  try {
    const sideBar = localStorage.getItem(STRING_SIDEBAR_EXPANDED_UMV3);
    if (sideBar !== null) {
      if (sideBar === STRING_FALSE) {
        return false;
      }
      if (sideBar === STRING_TRUE) {
        return true;
      }
    }
    return false;
  } catch (err) {
    return false;
  }
};

function Layout({ children }) {
  const { t } = useTranslation();
  const [expireToken, setExpireToken] = useState(true);
  const [expandedMenus, setExpandedMenus] = useState({});
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isSidebarExpanded, setIsSidebarExpanded] =
    useState(getSideBarStatus());
  const history = useHistory();
  const location = useLocation();
  const [sideBarColor, setSideBarColor] = useState(COLOR_AZUL_MAIN);
  const [userInfo, setUserInfo] = useState(null);

  const sidebarNavigation = [
    {
      name: t("menu_dashboard"),
      href: "/dashboard",
      icon: ChartBarSquareIcon,
    },
    {
      name: t("menu_clientes"),
      href: "/clientes",
      icon: UserGroupIcon,
      subMenu: [
        {
          name: t("menu_grupo_clientes"),
          href: "/clientes/listar-grupo-cliente",
        },
        { name: t("menu_tipo_cliente"), href: "/clientes/listar-tipo-cliente" },
        { name: t("menu_clientes"), href: "/clientes/listar-cliente" },
      ],
    },
    {
      name: t("menu_almacen"),
      href: "/almacen",
      icon: BuildingStorefrontIcon,
      subMenu: [{ name: t("menu_almacen"), href: "/almacen" }],
    },
    {
      name: t("menu_administracion"),
      href: "/administracion",
      icon: BuildingLibraryIcon,
      subMenu: [
        {
          name: t("menu_categorias"),
          href: "/administracion/listar-categorias",
        },
        { name: t("menu_productos"), href: "/administracion/listar-productos" },
        { name: t("menu_pais"), href: "/administracion/listar-pais" },
        { name: t("menu_ciudades"), href: "/administracion/listar-ciudades" },
        {
          name: t("menu_vendedores"),
          href: "/administracion/listar-vendedores",
        },
        { name: t("menu_estados"), href: "/administracion/listar-estado" },
        {
          name: t("menu_estado_pago"),
          href: "/administracion/listar-estado-pago",
        },
        {
          name: t("menu_estado_vehiculo"),
          href: "/administracion/listar-estado-vehiculo",
        },
        {
          name: t("menu_ejes_vehiculo"),
          href: "/administracion/listar-ejes-vehiculo",
        },
        {
          name: t("menu_quien_recibe_entrega"),
          href: "/administracion/listar-quien-recibe-entrega",
        },
        {
          name: t("menu_formulario"),
          href: "/administracion/listar-formulario",
        },
        {
          name: t("menu_grupo_geocerca"),
          href: "/administracion/listar-grupo-geocerca",
        },
        {
          name: t("menu_progress_bar"),
          href: "/administracion/listar-progress-bar",
        },
        { name: t("menu_persona"), href: "/administracion/listar-persona" },
        {
          name: t("menu_tipo_chofer"),
          href: "/administracion/listar-tipo-chofer",
        },
        {
          name: t("menu_prioridad_entrega"),
          href: "/administracion/listar-prioridad-entrega",
        },
      ],
    },
    {
      name: t("menu_asignacion"),
      href: "/asignacion",
      icon: QueueListIcon,
    },
    {
      name: t("menu_seguimiento"),
      href: "/seguimiento",
      icon: MapPinIcon,
      subMenu: [
        { name: t("menu_mapa"), href: "/seguimiento/mapa-seguimiento" },
        { name: t("menu_grilla"), href: "/seguimiento/listar-seguimiento" },
      ],
    },
    {
      name: t("menu_incidente"),
      href: "/incidente",
      icon: TriangleAlertIcon,
      subMenu: [
        {
          name: t("menu_estado_incidente"),
          href: "/incidente/listar-estados-incidente",
        },
        {
          name: t("menu_lista_incidentes"),
          href: "/incidente/listar-incidentes",
        },
      ],
    },
    {
      name: t("menu_viaje"),
      href: "/viaje",
      icon: Rotate3DIcon,
      subMenu: [
        {
          name: t("menu_gestionar_transportadora_sindicato"),
          href: "/viaje/listar-transportadora",
        },
        {
          name: t("menu_formulario_viaje"),
          href: "/viaje/listar-formulario-viaje",
        },
        {
          name: t("menu_estado_solicitud"),
          href: "/viaje/listar-estado-solicitud",
        },
        { name: t("menu_tipo_carguio"), href: "/viaje/listar-tipo-carguio" },
        //{ name: t("menu_kanban"), href: "/viaje/listar-kanban" },
        { name: t("menu_kanban_viaje"), href: "/viaje/listar-kanban-viaje" },
        {
          name: t("menu_kanban_producto"),
          href: "/viaje/listar-kanban-producto",
        },
        //{ name: t("menu_lista_viajes"), href: "/viaje/listar-viajes" },
        // { name: t("menu_registro_camiones"), href: "/viaje/listar-registro-camiones" },
        {
          name: t("menu_formulario_programacion_camiones"),
          href: "/viaje/listar-programacion-camiones",
        },
        {
          name: t("menu_respuesta_solicitud_programacion_camiones"),
          href: "/viaje/listar-estado-solicitud-programacion-camiones",
        },
        {
          name: t("menu_solicitud_producto"),
          href: "/viaje/listar-solicitud-producto",
        },
        {
          name: t("menu_seguimiento_viaje"),
          href: "/viaje/mapa-viaje",
        },
      ],
    },
    {
      name: t("menu_usuarios"),
      href: "/usuario",
      icon: UserIcon,
      subMenu: [
        { name: t("menu_usuarios_web"), href: "/usuarios/listar-usuarios-web" },
        {
          name: t("menu_usuarios_movil"),
          href: "/usuarios/listar-usuarios-movil",
        },
        {
          name: t("menu_rol_usuario_web"),
          href: "/usuarios/listar-rol-usuario-web",
        },
        {
          name: t("menu_tipo_usuario_movil"),
          href: "/usuarios/listar-tipo-usuario-movil",
        },
      ],
    },
    {
      name: t("menu_reportes"),
      href: "/reportes",
      icon: ChartColumn,
      subMenu: [
        {
          name: t("menu_reporte_estado_entregas"),
          href: "/reportes/reporte-estado-entregas",
        },
        {
          name: t("menu_resumen_entregas"),
          href: "/reportes/reporte-resumen-entregas",
        },
      ],
    },
    {
      name: t("menu_salir"),
      href: "/salir",
      icon: ArrowLeftStartOnRectangleIcon,
    },
  ];

  const nextPage = (page) => {
    try {
      history.push(`${page}`);
    } catch (err) {
      console.log("nextPage err");
      console.log(err);
    }
  };

  useEffect(() => {
    const sideBar = localStorage.getItem(STRING_SIDEBAR_EXPANDED_UMV3);
    // console.log('sideBar');
    // console.log(sideBar);
    // console.log(typeof sideBar);
    if (sideBar !== null) {
      if (sideBar === STRING_FALSE) {
        // console.log('side bar false');
        setIsSidebarExpanded(false);
      }
      if (sideBar === STRING_TRUE) {
        // console.log('side bar true');
        setIsSidebarExpanded(true);
      }
    }
    const resp = isTokenExpire();
    if (resp) {
      nextPage("/landing");
    } else {
      setExpireToken(false);
    }
    obtenerUsuarioWeb();
  }, []);

  const obtenerUsuarioWeb = async () => {
    try {
      const response = await obtenerInfoUsuario();
      // console.log("response");
      // console.log(response);
      setUserInfo(response);
    } catch (error) {
      console.log("obtenerUsuarioWeb error");
    }
  };

  if (expireToken) {
    return <div></div>;
  }

  const handleToggleMenu = (name) => {
    setExpandedMenus((prev) => ({ ...prev, [name]: !prev[name] }));
  };

  const handleToggleSidebar = () => {
    localStorage.setItem(STRING_SIDEBAR_EXPANDED_UMV3, !isSidebarExpanded);
    setIsSidebarExpanded((prevState) => !prevState);
  };

  if (expireToken) {
    return <div></div>;
  }

  const isCurrentPage = (href, subMenu) => {
    if (subMenu) {
      return subMenu.some((sub) => location.pathname === sub.href);
    }
    return location.pathname === href;
  };

  const handleNavigate = (href) => {
    // console.log('handleNavigate');
    // console.log(href);
    history.push(href);
    setIsMobileMenuOpen(false);
  };

  const renderMenuItem = (item, index) => {
    const isExpanded = expandedMenus[item.name];
    const isCurrent = isCurrentPage(item.href, item.subMenu);
    const hasSubMenu = item.subMenu && item.subMenu.length > 0;

    return (
      <div key={index} className="mb-1">
        <div
          className={`flex items-center justify-between p-3 rounded-lg cursor-pointer transition-all ${
            isCurrent
              ? "bg-blue-700 text-white"
              : "text-blue-100 hover:bg-blue-700 hover:text-white"
          }`}
          onClick={() => {
            if (hasSubMenu) {
              handleToggleMenu(item.name);
            } else {
              handleNavigate(item.href);
            }
          }}
          title={item.name}
        >
          <div className="flex items-center gap-3 flex-1 min-w-0">
            {item.icon && <item.icon className="h-5 w-5 flex-shrink-0" />}
            {isSidebarExpanded && (
              <span className="font-medium truncate">{item.name}</span>
            )}
          </div>
          {hasSubMenu && isSidebarExpanded && (
            <div className="flex-shrink-0 ml-2">
              {isExpanded ? (
                <ChevronDownIcon className="h-4 w-4" />
              ) : (
                <ChevronRightIcon className="h-4 w-4" />
              )}
            </div>
          )}
        </div>

        {/* SubMenu */}
        {hasSubMenu && isExpanded && isSidebarExpanded && (
          <div className="ml-8 mt-1 space-y-1">
            {item.subMenu.map((subItem, subIndex) => (
              <div
                key={subIndex}
                className={`p-2 pl-4 rounded-lg cursor-pointer text-sm transition-all ${
                  location.pathname === subItem.href
                    ? "bg-blue-700 text-white"
                    : "text-blue-100 hover:bg-blue-700 hover:text-white"
                }`}
                onClick={() => handleNavigate(subItem.href)}
              >
                {subItem.name}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  return (
    <div className="flex h-screen overflow-hidden">
      {/* Mobile Menu Toggle Button */}
      <button
        onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
        className="lg:hidden fixed top-4 left-4 z-50 p-2 bg-blue-600 text-white rounded-lg shadow-lg"
      >
        <Bars3Icon className="h-6 w-6" />
      </button>

      {/* Mobile Overlay */}
      {isMobileMenuOpen && (
        <div
          className="lg:hidden fixed inset-0 bg-black bg-opacity-50 z-40"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}

      {/* Sidebar */}
      <aside
        className={`fixed lg:static inset-y-0 left-0 z-40 flex flex-col h-full transition-all duration-300 ${
          isSidebarExpanded ? "w-64" : "w-20"
        } ${isMobileMenuOpen ? "translate-x-0" : "-translate-x-full lg:translate-x-0"}`}
        style={{ backgroundColor: sideBarColor }}
      >
        {/* Logo & Toggle */}
        <div className="flex items-center justify-between p-4 border-b border-blue-500">
          <div className="flex items-center gap-3 min-w-0">
            <div className="flex-shrink-0 w-10 h-8 bg-white rounded-lg flex items-center justify-center">
              <span className="text-blue-600 font-bold text-lg">
                {t("label_tms")}
              </span>
            </div>
            {/* {isSidebarExpanded && (
              <span className="text-xl font-bold text-white truncate">{t("label_ultima_milla")}</span>
            )} */}
          </div>
          <button
            onClick={handleToggleSidebar}
            className="hidden lg:block text-white hover:bg-blue-700 p-1 rounded transition-colors"
          >
            <ChevronRightIcon
              className={`h-5 w-5 transition-transform ${
                isSidebarExpanded ? "rotate-180" : ""
              }`}
            />
          </button>
        </div>

        {/* Navigation */}
        <nav className="flex-1 p-4 overflow-y-auto">
          {sidebarNavigation.map((item, index) => renderMenuItem(item, index))}
        </nav>

        {/* Footer Version */}
        <div className="p-4 border-t border-blue-500">
          {isSidebarExpanded && (
            <p className="text-xs text-blue-200 text-center">
              Version {VERSION_TMS}
            </p>
          )}
        </div>
      </aside>

      {/* Content Area */}
      {/* <main className="flex-1 min-h-screen bg-gray-50 lg:ml-0">
        {children}
      </main> */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Header */}
        <LayoutHeader userInfo={userInfo} />

        {/* Page Content */}
        <main className="flex-1 overflow-y-auto ">{children}</main>
      </div>
    </div>
  );
}
export default Layout;
